import { render, staticRenderFns } from "./HostAccess.vue?vue&type=template&id=05f202d2&"
import script from "./HostAccess.vue?vue&type=script&lang=js&"
export * from "./HostAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports